import { ChangeDetectionStrategy, Component, computed, effect, inject, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomActiveCartService } from '@cart/data-access';
import { CartUndoService } from '@cart/feature';
import { ProductCarouselComponent } from '@sdvor/product/ui/v2';
import { WindowRef } from '@spartacus/core';
import {
  CartEmptyComponent,
  CartHeaderComponent,
  CartListComponent,
  CartTotalsComponent,
  CartUndoDeleteToastComponent,
} from '../../components';

@Component({
  selector: 'sd-cart-page',
  imports: [
    CartListComponent,
    CartEmptyComponent,
    CartHeaderComponent,
    ProductCarouselComponent,
    CartUndoDeleteToastComponent,
    CartTotalsComponent,
  ],
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartPageComponent {
  private cartUndoService = inject(CartUndoService);
  private customActiveCartService = inject(CustomActiveCartService);
  private windowRef = inject(WindowRef);

  protected cart = toSignal(this.customActiveCartService.getActive(), { initialValue: null });
  protected entries = toSignal(this.customActiveCartService.getEntries(), { initialValue: [] });
  protected entriesCodes = computed(
    () =>
      this.entries()
        .map((e) => e.product?.code)
        .filter((code) => Boolean(code)) as string[],
  );
  protected isEmptyCart = computed(() => this.entries().length === 0);
  protected isBrowser = this.windowRef.isBrowser();

  constructor() {
    effect(() => {
      const revertEntryTriggered = this.cartUndoService.revertEntryTriggered();
      untracked(() => {
        if (revertEntryTriggered && revertEntryTriggered.product?.code && revertEntryTriggered.quantity) {
          this.customActiveCartService.restoreEntry(revertEntryTriggered);
          this.cartUndoService.clear();
        }
      });
    });
  }
}
